import { render, staticRenderFns } from "./CmgMemberRewardItem.vue?vue&type=template&id=15059ed7&scoped=true&lang=pug&"
import script from "./cmg-member-reward-item.ts?vue&type=script&lang=ts&"
export * from "./cmg-member-reward-item.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMemberRewardItem.vue?vue&type=style&index=0&id=15059ed7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15059ed7",
  null
  
)

export default component.exports